import { defineStore } from "pinia";

// Bascules "Outils de développement" (Menu.vue) : réglages client-only, persistés en
// localStorage, désactivés par défaut — jamais des réglages métier (cf. options.store.ts /
// getOptionByCode pour ça). Suit le même modèle que performance.store.ts, dans un store séparé
// pour ne pas mélanger des bascules dev sans rapport avec le suivi des performances.
export const useDevOptionsStore = defineStore("devOptions", {
    state: () => ({
        // Détail de cellule sur l'écran Compteurs (clic -> décomposition Besoin/Dispo ou par verrat).
        showCompteurCellDetail: false as boolean,
    }),
    actions: {
        toggleCompteurCellDetail() {
            this.showCompteurCellDetail = !this.showCompteurCellDetail;
        },
    },
    persist: {
        pick: ['showCompteurCellDetail'],
    },
});
